import { render } from "./optionInputs.vue?vue&type=template&id=c25d661c"
import script from "./optionInputs.vue?vue&type=script&lang=js"
export * from "./optionInputs.vue?vue&type=script&lang=js"

import "./optionInputs.vue?vue&type=style&index=0&id=c25d661c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__